import cx from 'classnames';
import React, { Component, createRef, PropsWithChildren } from 'react';
import { Transition } from 'react-transition-group';

import s from './Container.css';

// This height is also defined in Filters.css in class .line
const LINE_HEIGHT = 56;

type Props = {
    title: string;
    isActive: boolean;
    style?: { [key: string]: string | number };
};

type State = {
    opened: boolean;
};
type Status = 'exiting' | 'exited' | 'entered' | 'entering';

export class FilterContainer extends Component<PropsWithChildren<Props>, State> {
    private nodeRef = createRef<HTMLDivElement>();

    constructor(props: Props) {
        super(props);
        this.state = {
            opened: false,
        };
        this.open = this.open.bind(this);
    }

    open(): void {
        this.setState(() => ({ opened: !this.state.opened }));
    }

    getOpenContainerMaxHeight(): number {
        const childrenLength = React.Children.count(this.props.children);
        // 1 line height for the title and one per child
        return childrenLength * LINE_HEIGHT + LINE_HEIGHT;
    }

    getTransitionTime(): number {
        return React.Children.count(this.props.children) / 40;
    }

    render(): JSX.Element {
        const { title, isActive, children, style = {} } = this.props;
        const transitionStyles = {
            entering: { maxHeight: this.getOpenContainerMaxHeight() },
            entered: { maxHeight: this.getOpenContainerMaxHeight() },
            exiting: { maxHeight: LINE_HEIGHT },
            exited: { maxHeight: LINE_HEIGHT },
        };
        return (
            <Transition
                in={this.state.opened}
                timeout={{
                    enter: 0,
                    exit: 200,
                }}
                nodeRef={this.nodeRef}
            >
                {/** @ts-ignore */}
                {(status: Status) => (
                    <div
                        ref={this.nodeRef}
                        className={s.container}
                        style={{
                            ...transitionStyles[status],
                            transition: `${this.getTransitionTime()}s all ease-in-out`,
                            ...style,
                        }}
                    >
                        <button
                            type="button"
                            className={cx(s.button, { [s.active]: isActive })}
                            onClick={this.open}
                        >
                            {title}{' '}
                            <div
                                className={cx(s.triangle, {
                                    [s.down]: !this.state.opened,
                                    [s.up]: this.state.opened,
                                })}
                            />
                        </button>
                        {this.state.opened && children}
                    </div>
                )}
            </Transition>
        );
    }
}
